import { HTMLAttributes, MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useCookieBanner } from 'hooks';
import { MenuItem } from 'netline-ui';
import { CloseableComponentProps } from 'types';

type CookieSettingsProps = CloseableComponentProps & HTMLAttributes<HTMLLIElement>;

const CookieSettings = ({ onMenuClose, ...props }: CookieSettingsProps) => {
  const { t } = useTranslation();
  const { openSettings } = useCookieBanner();
  const handleCookieSettingsClick = useCallback(
    (event: MouseEvent<HTMLLIElement>) => {
      openSettings();
      onMenuClose?.(event);
    },
    [onMenuClose, openSettings],
  );

  return (
    <MenuItem data-testid="CookieSettings-root" onClick={handleCookieSettingsClick} {...props}>
      {t('cookie.settings_btn')}
    </MenuItem>
  );
};

export default CookieSettings;
